import React, { useEffect, useState } from "react";
import { Bell, Gamepad2, Trophy, Users, MessageSquare, Clock } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { fmtNumber } from "@/lib/i18n";

const API = process.env.REACT_APP_BACKEND_URL;
const LANG_FLAG = { ar: "🇸🇦", en: "🇬🇧", it: "🇮🇹", fr: "🇫🇷" };

function StatCard({ icon: Icon, label, value, sub, testid }) {
  return (
    <div className="rounded-2xl border border-stoneLine bg-card p-4 flex items-start gap-3" data-testid={testid}>
      <span className="w-9 h-9 rounded-full bg-ochre/10 text-ochre flex items-center justify-center shrink-0"><Icon className="w-4 h-4" /></span>
      <div className="min-w-0">
        <div className="stat-number text-2xl text-ink leading-none" data-testid={`${testid}-value`}>{value}</div>
        <div className="text-[11px] text-muted-foreground mt-1 leading-tight">{label}</div>
        {sub && <div className="text-[11px] text-ink/70 mt-1">{sub}</div>}
      </div>
    </div>
  );
}

export default function AdminStats() {
  const { lang, t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/admin/stats`, { credentials: "include" }).then((r) => (r.ok ? r.json() : null)).then(setStats).catch(() => setStats(null));
  }, []);

  if (!stats) return null;
  const n = (v) => fmtNumber(v, lang);
  const byLang = Object.entries(stats.push.by_lang).map(([l, c]) => `${LANG_FLAG[l] || l} ${c}`).join(" · ");

  return (
    <section className="mb-8" data-testid="admin-stats">
      <h2 className="text-[10px] uppercase tracking-[0.18em] text-ochre font-semibold mb-3">{t("admin_stats")}</h2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <StatCard icon={Bell} label={t("admin_stats_push")} value={n(stats.push.total)} sub={byLang || null} testid="stat-push" />
        <StatCard icon={Users} label={t("admin_stats_players")} value={n(stats.week.players)} sub={`${t("admin_stats_all_players")}: ${n(stats.week.all_time_players)}`} testid="stat-players" />
        <StatCard icon={Gamepad2} label={t("admin_stats_games")} value={n(stats.week.games)} testid="stat-games" />
        <StatCard icon={Trophy} label={t("admin_stats_perfect")} value={n(stats.week.perfect)} testid="stat-perfect" />
        <StatCard icon={Clock} label={t("admin_stats_pending")} value={n(stats.reviews.pending)} testid="stat-pending" />
        <StatCard icon={MessageSquare} label={t("admin_stats_approved")} value={n(stats.reviews.approved)} testid="stat-approved" />
      </div>
    </section>
  );
}
